import React from 'react';
import { Spinner } from '@paycor/picl/icon';
import styles from './LoadingSplashScreen.module.scss';
import PropTypes from 'prop-types';

LoadingSplashScreen.propTypes = {
	pageLoad: PropTypes.bool.isRequired
};

function LoadingSplashScreen({ pageLoad }) {
	return (
		<div className={pageLoad ? styles.pageLoad : styles.componentLoad}>
			<Spinner size="24px" animation="spin" />
		</div>
	);
}

export default LoadingSplashScreen;
